import PageBreadcrumbs from "./../SharedComponent/page-breadcrumbs";
import React, { useEffect } from "react";

const ContactUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div>
      <PageBreadcrumbs
        title="Contact Us"
        subtitle="Connect with us"
        breadcrumbs={{
          currentPage: "Contact Us",
          items: [{ name: "Home", href: "/contactus" }],
        }}
      />
    </div>
  )
};

export default ContactUs;
